import { useState } from "react";
import PropTypes from "prop-types";

const BlockDashboardInfo = (props) => {
  const { label, value, dividerClass, onClick, onViewClick, viewColor, actionLabel, actionColor } = props;
  const [showBtn, setShowBtn] = useState(false);

  const handleViewClick = () => {
    if (onViewClick) {
      onViewClick();
    } else {
      setShowBtn((prev) => !prev);
    }
  };

  const colorClass = viewColor || "text-[#FFE500]";
  const btnColor = actionColor || "bg-[#6A4CFF]";

  return (
    <>
      <div className="flex justify-center items-center w-full">
        <div className="flex flex-col items-center">
          <span className="text-white text-lg font-medium">{label}</span>
          <div className="mt-[5px]">
            {!showBtn ? (
              <div
                className="flex flex-col items-center cursor-pointer"
                onClick={handleViewClick}
              >
                <span className={`${colorClass} text-tiny mb-[5px]`}>view</span>
                <div className={dividerClass} />
              </div>
            ) : (
              <button
                onClick={onClick}
                className={`font-bold text-sm text-white ${btnColor} rounded-lg px-[8px] py-[2px]`}
              >
                {actionLabel || `${label} Now`}
              </button>
            )}
          </div>
          <div className="text-white font-bold mt-[8px] text-2xl">
            {value !== undefined && value !== null ? value : '-'}
          </div>
        </div>
      </div>
    </>
  );
};

BlockDashboardInfo.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  dividerClass: PropTypes.string,
  onClick: PropTypes.func,
  onViewClick: PropTypes.func,
  viewColor: PropTypes.string,
  actionLabel: PropTypes.string,
  actionColor: PropTypes.string,
};

export default BlockDashboardInfo;